import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';

// CSS for large select
const largeSelectCSS = `
    font-size: 1.14285714em !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    min-height: 42.69px !important;
`;

const Select = styled(
    React.forwardRef((props, ref) => {
        const handleSelectRef = React.useCallback((instance) => {
            const domNode = instance ? ReactDOM.findDOMNode(instance) : null;
            if (ref) {
                if (typeof ref === 'function') {
                    ref(domNode);
                } else if (ref && typeof ref === 'object') {
                    ref.current = domNode;
                }
            }
        }, [ref]);

        return <Dropdown {...props} selection ref={handleSelectRef} />;
    })
)`
    ${props => props.size === 'large' && largeSelectCSS}
`;

export default Select;
